import type {RuleValidationErrors} from '../types';
import {ContentsType} from './constants';
import {ContentsRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateContentsRule = <T extends ContentsRule = ContentsRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (rule.elementValue1 === '') {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateContentsRule;
